<z-embedded-ui-overlay
  [overlay]="overlay"
  [url]="url()"
  [loading]="loading()"
  [loadingText]="'Resolving web UI URL…'"
  [emptyText]="'Web UI is not available. The service needs a running container.'"
  [newTabTitle]="'Open web UI in new tab'"
  [trayId]="key"
  [trayCaption]="'Web UI'"
  [trayTitle]="serviceStackName() || 'service'"
  [reloadTitle]="'Reload web UI'"
  (reload)="onReload$.next()"
  (openInNewTab)="onOpenInNewTab$.next()"
  (closed)="onClose$.next()"
/>
